<script>
import GroupIndex from "../../../abstract/GroupIndex.js";

export default GroupIndex.extend({
  props: {
    profiles: Array
  },
  data() {
    return {
      options: {
        profile: null
      },
      sortColumn: "enrollment_year",
      sortColumnDirection: "desc",
      type: "graduate"
    };
  }
});
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/views/groups/graduate/Index.vue